import { render } from "./Brush.vue?vue&type=template&id=7fce821c"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/Brush.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7fce821c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7fce821c', __exports__)) {
    api.reload('7fce821c', __exports__)
  }
  
  module.hot.accept("./Brush.vue?vue&type=template&id=7fce821c", () => {
    api.rerender('7fce821c', render)
  })

}


export default __exports__